import React, { useEffect, useState, useRef } from "react";
import Footer from "../common/Footer/Footer";
import Header from "../header/Header";
import { getFromLocalStorage } from "../../services/helper/cl_Helper";
import { useNavigate } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { getRealBalance, setCrashGames } from "../signIn/cl_SignInSlice";
import BottomMenu from "../home/BottomMenu/BottomMenu";
import PushNotificationModal from "../home/landingBanners";
import AssistantChat from "../common/AssistantChat/AssistantChat";
import { setIsActive } from "../chatbot/cl_ChatbotSlice";
import icons from "../../assets/images/sprite-other-icons.svg";
import { fetchBanners } from "../banners/cl_Banners";
import { setGameDetails, setGamePopup } from "../crashGames/cl_CrashSlice";
import { setSignupSuccess } from "../signUp/cl_SignUpSlice";
import useFilterGamesByType from "../../services/helper/filterGamesByType";
import LoyaltyConfig from "../../assets/loyaltyPointsConfig.json";
import { Outlet, useLocation } from "react-router-dom";

// Add this small component at the top of the file (after imports)
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (typeof window !== "undefined" && window.scrollTo) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
}

const HomeLayout = () => {
  const topRef = useRef(null);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(""); // Track active tab
  const [chatTheme, setChatTheme] = useState("light");
  const chatbotActive = useSelector(state => state.chatbot.isActive);
  const dispatch = useDispatch();
  const shouldIgnoreRoute = (labelName, menuLink) => {
    const ignoredRoutes = ["loyaltyprelogin", "promotions", "offers"];

    // Check labelName (case insensitive)
    if (
      labelName &&
      ignoredRoutes.some((route) =>
        labelName.toLowerCase().includes(route.toLowerCase())
      )
    ) {
      return true;
    }

    // Check menuLink path
    if (
      menuLink &&
      ignoredRoutes.some((route) =>
        menuLink.toLowerCase().includes(route.toLowerCase())
      )
    ) {
      return true;
    }

    return false;
  };

  useEffect(() => {
    // REMOVE this line, it's no longer needed:
    // topRef.current.scrollIntoView(true);
  }, []);
  const location = useLocation();
  const [pathChange, setPathChange] = useState(false);
  const { crashGames } = useSelector((state) => state?.signIn);
  const token = getFromLocalStorage("gk");
  const { signupSuccess } = useSelector((state) => state?.signUp);
  const [isNewSignup, setIsNewSignup] = useState(() => {
    return sessionStorage.getItem("isNewSignup") === "true";
  });
  const { userLoyalty } = useSelector((state) => state?.signIn);
  useEffect(() => {
    if (location.pathname === "/responsibleGambling") {
      setPathChange(true);
    } else {
      setPathChange(false);
    }
    if (location.pathname === "/") {
      dispatch(setCrashGames(false));
      if (token) {
        dispatch(getRealBalance());
      }
    }
  }, [location, token]);

  // function initFreshChat() {
  //   if (typeof window.fcWidget !== "undefined") {
  //     window.fcWidget.init({
  //       token: "OMIymK3pvcEm9ly1YGI5QmIw3qhzXFfBMjEcqpqDdhY=",
  //       host: "https://uae.fw-cdn.com",
  //     });
  //   } else {
  //     console.error("Freshchat widget not loaded.");
  //   }
  // }

  // function initialize(i, t) {
  //   var e;
  //   if (i.getElementById(t)) {
  //     initFreshChat();
  //   } else {
  //     e = i.createElement("script");
  //     e.id = t;
  //     e.async = true;
  //     e.src = "//uae.fw-cdn.com/40192381/119724.js";
  //     e.setAttribute("chat", "true");
  //     e.onload = initFreshChat;
  //     i.head.appendChild(e);
  //   }
  // }

  // function initiateFreshchat() {
  //   initialize(document, "Freshchat-js-sdk");
  // }

  // const handleChatClick = () => {
  //   initiateFreshchat();
  //   if (window.fcWidget) {
  //     window.fcWidget.open();
  //   }
  // };

  function adjustMainSectionHeight() {
    requestAnimationFrame(() => {
      const depositHeader = document.querySelector(".SB-deposit-header");
      const mainHeader = document.querySelector(".SB-mainHeader");
      const mobileFooter = document.querySelector(".SB-mobile-footer");
      const mainSectionContent = document.querySelector(
        ".SB-mainSection-content"
      );

      const depositHeight = depositHeader?.offsetHeight || 0;
      const mainHeaderHeight = mainHeader?.offsetHeight || 0;
      const mobileFooterHeight = mobileFooter?.offsetHeight || 0;

      const adjustedHeight = `calc(100dvh - ${
        mainHeaderHeight + depositHeight + mobileFooterHeight + 12
      }px)`;
      if (mainSectionContent) {
        mainSectionContent.style.height = adjustedHeight;
      }
    });
  }
  const [showBonusModal, setShowBonusModal] = useState(false);
  const [bonusAmount, setBonusAmount] = useState(0);
  const { balanceDetails } = useSelector((state) => state?.signIn);
  const previousLockedBonusRef = useRef(null);

  useEffect(() => {
    if (balanceDetails?.bonus_summary?.result?.data) {
      const currentLockedBonus =
        balanceDetails.bonus_summary.result.data.lockedBonus;

      if (
        previousLockedBonusRef.current !== null &&
        previousLockedBonusRef.current > currentLockedBonus
      ) {
        const convertedAmount =
          previousLockedBonusRef.current - currentLockedBonus;
        setBonusAmount(convertedAmount);
        setShowBonusModal(true);
      }

      previousLockedBonusRef.current = currentLockedBonus;
    }
  }, [balanceDetails?.bonus_summary?.result?.data]);

  useEffect(() => {
    window.addEventListener("resize", adjustMainSectionHeight);

    const observer = new MutationObserver(() => {
      adjustMainSectionHeight();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style", "class"],
    });

    return () => {
      window.removeEventListener("resize", adjustMainSectionHeight);
      observer.disconnect();
    };
  }, []);

  // useEffect(() => {
  //   initiateFreshchat();
  // }, []);

  const style = document.createElement("style");
  style.textContent = `
      #fc_frame{
      z-index: 998 !important;
      }
       #fc_frame.fc-open{
        z-index: 1000 !important;       
        
      }

      .fc-widget-normal.fc-open {
        bottom: 20px !important;
        right: calc(50% - 255px + 20px) !important;
        left: auto !important;
        
      }
      
      @media screen and (max-width: 767px) {
        .custom_fc_frame {
          right: 20px !important;
        }
      }
    `;
  document.head.appendChild(style);
  const { superBannersData } = useSelector((state) => state.banners);
  const [showPushModal, setShowPushModal] = useState(false);
  const [selectedBanner, setSelectedBanner] = useState(null);

  useEffect(() => {
    dispatch(fetchBanners());
  }, [dispatch]);

  const findEligibleBanner = (banners, isLoggedIn) => {
    if (!Array.isArray(banners)) return null;

    return banners.find(
      (banner) =>
        banner.is_active &&
        banner.master_typeid === 3 &&
        (isLoggedIn
          ? !banner.before_login && banner.after_login
          : banner.before_login && !banner.after_login)
    );
  };

  useEffect(() => {
    const seenBanners = JSON.parse(localStorage.getItem("seenBanners") || "[]");
    const isLoggedIn = token && token.length > 0;
    const isJustSignedUp =
      signupSuccess || sessionStorage.getItem("isNewSignup") === "true";

    const modalBanner = findEligibleBanner(superBannersData, isLoggedIn);

    if (
      modalBanner &&
      !seenBanners.includes(modalBanner.banner_id) &&
      !isJustSignedUp
    ) {
      setSelectedBanner(modalBanner);
      setShowPushModal(true);
    }
  }, [token, superBannersData, signupSuccess]);

  useEffect(() => {
    const cleanup = () => {
      if (!token) {
        sessionStorage.removeItem("isNewSignup");
        setIsNewSignup(false);
      }
    };

    window.addEventListener("beforeunload", cleanup);
    return () => {
      window.removeEventListener("beforeunload", cleanup);
      cleanup();
    };
  }, [token]);

  useEffect(() => {
    if (token) {
      const storedRoute = localStorage.getItem("intendedRoute");
      if (storedRoute) {
        try {
          const { labelName, menuLink, isGame } = JSON.parse(storedRoute);

          // Check if this route should be ignored
          if (shouldIgnoreRoute(labelName, menuLink)) {
            localStorage.removeItem("intendedRoute");
            return; // Exit early, don't navigate
          }

          localStorage.removeItem("intendedRoute");

          // dispatch(setHomePopUp(true));

          if (isGame) {
            const filteredGames = filterByGameType(labelName);
            const gamesList =
              filteredGames[0]?.game?.length > 0 ? filteredGames[0]?.game : [];
            navigate(`/games/${labelName}`, {
              state: {
                gamesList,
                title: labelName,
                game_type: labelName,
              },
            });
          } else if (
            labelName.toLowerCase() === "promotions" ||
            labelName.toLowerCase() === "offers"
          ) {
            navigate("/promotions");
          } else {
            navigate(menuLink);
          }
        } catch (error) {
          console.error("Error handling stored route:", error);
          localStorage.removeItem("intendedRoute");
        }
      }
    }
  }, [token]);

  const handleCloseModal = () => {
    setShowPushModal(false);

    if (selectedBanner) {
      const seenBanners = JSON.parse(
        localStorage.getItem("seenBanners") || "[]"
      );
      if (!seenBanners.includes(selectedBanner.banner_id)) {
        seenBanners.push(selectedBanner.banner_id);
        localStorage.setItem("seenBanners", JSON.stringify(seenBanners));
      }
    }
    setSelectedBanner(null);
  };

  useEffect(() => {
    const pendingGame = localStorage.getItem("pendingGame");

    if (pendingGame && token && location.pathname === "/") {
      try {
        const game = JSON.parse(pendingGame);
        dispatch(setGameDetails(game));
        dispatch(setGamePopup(true));
      } catch (error) {
        console.error("Error handling pending game:", error);
        localStorage.removeItem("pendingGame");
      }
    }
  }, [token, location.pathname]);

  const filterByGameType = useFilterGamesByType();
  useEffect(() => {
    if (token) {
      const storedRoute = localStorage.getItem("intendedRoute");
      if (storedRoute) {
        try {
          const { labelName, menuLink, isGame } = JSON.parse(storedRoute);
          localStorage.removeItem("intendedRoute");

          // dispatch(setHomePopUp(true));

          if (isGame) {
            const filteredGames = filterByGameType(labelName);
            const gamesList =
              filteredGames[0]?.game?.length > 0 ? filteredGames[0]?.game : [];
            navigate(`/games/${labelName}`, {
              state: {
                gamesList,
                title: labelName,
                game_type: labelName,
              },
            });
          } else if (
            labelName.toLowerCase() === "promotions" ||
            labelName.toLowerCase() === "offers"
          ) {
            navigate("/promotions");
          } else {
            navigate(menuLink);
          }
        } catch (error) {
          console.error("Error handling stored route:", error);
          localStorage.removeItem("intendedRoute");
        }
      }
    }
  }, [token]);

  useEffect(() => {
    if (token) {
      const pendingGame = localStorage.getItem("pendingGame");
      const intendedViewAll = localStorage.getItem("intendedViewAll");

      if (intendedViewAll) {
        try {
          const { categoryName, gamesList, type } = JSON.parse(intendedViewAll);

          // Check if this category should be ignored
          if (shouldIgnoreRoute(categoryName)) {
            localStorage.removeItem("intendedViewAll");
            return; // Exit early, don't navigate
          }

          localStorage.removeItem("intendedViewAll");

          // dispatch(setHomePopUp(true));

          if (type === "viewAll") {
            navigate(`/games/${categoryName}`, {
              state: {
                gamesList,
                title: categoryName,
                game_type: categoryName,
              },
            });
          }
        } catch (error) {
          console.error("Error handling viewAll route:", error);
          localStorage.removeItem("intendedViewAll");
        }
      } else if (pendingGame && location.pathname === "/") {
        try {
          const game = JSON.parse(pendingGame);
          dispatch(setGameDetails(game));
          dispatch(setGamePopup(true));
          localStorage.removeItem("pendingGame");
        } catch (error) {
          console.error("Error handling pending game:", error);
          localStorage.removeItem("pendingGame");
        }
      }
    }
  }, [token, location.pathname]);
  const handleCloseBonusModal = () => {
    setShowBonusModal(false);
  };

  const getLoyaltyContent = () => {
    if (
      userLoyalty?.lifeTimeCoins <=
      LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0].levelCutoff
    ) {
      return {
        image: require("../../assets/images/loyalty/dash.webp"),
        level: "DASH",
      };
    } else if (
      userLoyalty?.lifeTimeCoins <=
      LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1].levelCutoff
    ) {
      return {
        image: require("../../assets/images/loyalty/sprint.webp"),
        level: "SPRINT",
      };
    } else if (
      userLoyalty?.lifeTimeCoins <=
      LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2].levelCutoff
    ) {
      return {
        image: require("../../assets/images/loyalty/surge.webp"),
        level: "SURGE",
      };
    } else if (userLoyalty?.level === "level3") {
      return {
        image: require("../../assets/images/loyalty/thrill.webp"),
        level: "THRILL",
      };
    } else if (userLoyalty?.level === "level4") {
      return {
        image: require("../../assets/images/loyalty/boss.webp"),
        level: "BOSS",
      };
    }
    return {
      image: require("../../assets/images/loyalty/dash.webp"),
      level: "DASH",
    };
  };

  // Replace the useEffect that sets activeTab and resets chat state
  // and replace with this single useEffect:

  useEffect(() => {
    // Map pathname to tab key
    const pathToTab = (pathname) => {
      if (pathname === "/") return "home";
      if (pathname.startsWith("/loyalty")) return "loyalty";
      if (pathname.startsWith("/fasfascoins")) return "coins";
      if (pathname.startsWith("/profile")) return "profile";
      if (pathname.startsWith("/responsibleGambling")) return "profile";
      if (pathname.startsWith("/amlpolicy")) return "profile";
      if (pathname.startsWith("/chat")) return "chat";
      return "";
    };
    setActiveTab(pathToTab(location.pathname));

    // Always reset chatbotActive when leaving chat
    if (location.pathname !== "/chat") {
      dispatch(setIsActive(false));
    }
  }, [location.pathname, dispatch]);

  const [showAnonymousChat, setShowAnonymousChat] = useState(false);

  // Hide sticky chat icon after login
  useEffect(() => {
    if (token && showAnonymousChat) setShowAnonymousChat(false);
  }, [token]);

  return (
    <React.Fragment>
      <ScrollToTop />
      <div
        className={`SB-Lite ${location.pathname === "/" ? "SB-homePage" : ""} ${
          token?.length === 0 && "SB-nonLoggedIn"
        } ${crashGames ? "SB-crashGames-page" : ""} ${activeTab === "chat" || chatbotActive ? "chat-active" : ""} SB-myAccountPage`}
        ref={topRef}
      >
        <PushNotificationModal
          isOpen={showPushModal}
          onClose={handleCloseModal}
          selectedBanner={selectedBanner}
        />
        <div className="SB-layout-header" id="page-layoutHeader">
          {/* Always render Header except on /chat */}
          {location.pathname !== "/chat" && <Header />}
        </div>
        <div className="SB-container">
          <div className="SB-layout-content">
            <div className="SB-mainSection">
              <div className="SB-mainSection-content">
                <Outlet />
                {location.pathname !== "/chat" && <Footer />}
              </div>
            </div>
          </div>
        </div>
        {token?.length > 0 ? (
          <BottomMenu activeTab={activeTab} setActiveTab={setActiveTab} />
        ) : null}
        {signupSuccess && (
          <div
            className="SB-modal SB-registerSuccess-modal SB-modal-medium open"
            id="SB-registerSuccess-modal"
          >
            <div className="SB-modal-dialog">
              <div className="SB-modal-content">
                <div
                  className="SB-modal-close"
                  onClick={() => dispatch(setSignupSuccess(false))}
                >
                  <div className="SB-iconSVG" title="close">
                    <svg xmlns="http://www.w3.org/2000/svg">
                      <use xlinkHref={`${icons}#icon-close`}></use>
                    </svg>
                  </div>
                </div>
                <div className="SB-modal-header">
                  <iframe src="https://lottie.host/embed/e9255bf4-e53b-4667-8025-59d2045d704e/vgc5wxHHuj.json" title="lottie anim"></iframe>
                  <div className="SB-modal-title">Welcome aboard!</div>
                </div>
                <div className="SB-modal-body">
                  <p>
                    Make your first deposit to unlock your welcome bonus and
                    access to free games.
                  </p>
                </div>
                <div className="SB-modal-footer">
                  <div className="SB-btnContainer">
                    <button
                      className="btn SB-btnDeposit SB-btnSecondary active SB-btnLarge"
                      onClick={() => {
                        dispatch(setSignupSuccess(false));
                        sessionStorage.setItem("isNewSignup", "true");
                        setIsNewSignup(true);
                        navigate("/deposit");
                      }}
                    >
                      Deposit Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {showBonusModal && (
          <div
            className="SB-modal SB-loyaltyLevel-modal open"
            id="SB-loyaltyLevel-modal"
          >
            <div className="SB-modal-dialog">
              <div className="SB-modal-content">
                <div className="SB-modal-close" onClick={handleCloseBonusModal}>
                  <div className="SB-iconSVG" title="close">
                    <svg xmlns="http://www.w3.org/2000/svg">
                      <use xlinkHref={`${icons}#icon-close`}></use>
                    </svg>
                  </div>
                </div>
                <div className="SB-modal-body">
                  <div
                    className="SB-loyaltyLevel-success"
                    id="SB-loyaltyLevel-success"
                  >
                    <img
                      src={getLoyaltyContent().image}
                      alt={getLoyaltyContent().level.toLowerCase()}
                    />
                    <div className="SB-confetti">
                      <div className="SB-confetti-Before"></div>
                    </div>
                    <div className="SB-modal-header">
                      <div className="SB-modal-title">Congratulations</div>
                      <p>
                        {bonusAmount.toFixed(2)} KES bonus added to your cash
                        balance
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* Sticky Chat Icon for Anonymous Users */}
        {!token && !chatbotActive && !showAnonymousChat && (
          <button
            className="sticky-anon-chat-btn"
            style={{
              position: "fixed",
              bottom: "24px",
              right: "calc(max(0px, (100vw - 516px) / 2) + 20px)",
              zIndex: 1002,
              background: "#5142FC",
              borderRadius: "50%",
              boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
              width: "60px",
              height: "60px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "none",
              cursor: "pointer",
              flexDirection: "column",
              gap: "2px"
            }}
            onClick={() => {
              dispatch(setIsActive(true));
              navigate("/chat");
            }}
            aria-label="Open Chat"
          >
            <div className="SB-iconSVG" style={{ width: "26px", height: "26px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <svg xmlns="http://www.w3.org/2000/svg" style={{ width: "26px", height: "26px", fill: "#fff" }}>
                <use xlinkHref={`${icons}#icon-chat`} />
              </svg>
            </div>
            <span style={{ color: "#fff", fontSize: "9px", fontWeight: 600, letterSpacing: "0.3px", lineHeight: 1 }}>Chat</span>
          </button>
        )}
        {/* Anonymous Chat Window */}
        {!token && showAnonymousChat && (
          <div style={{ position: "fixed", top: 0, bottom: 0, left: "calc(max(0px, (100vw - 516px) / 2))", width: "min(100vw, 516px)", zIndex: 1003, display: "flex", flexDirection: "column" }}>
            <AssistantChat forceActive forceAnonymous onClose={() => { setShowAnonymousChat(false); dispatch(setIsActive(false)); }} />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default HomeLayout;
